import { Circle, CircleCheck, CircleX, type LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"
import type { ExportStatusClass } from "@/components/maps/orderDetails/OrderDetailsDialog"

const ICON: Record<ExportStatusClass, LucideIcon> = {
  success: CircleCheck,
  error: CircleX,
  pending: Circle,
  none: Circle,
}

const COLOR: Record<ExportStatusClass, string> = {
  success: "text-green-600",
  error: "text-red-600",
  pending: "text-muted-foreground",
  none: "text-muted-foreground",
}

/** The export-status mark shared by the classic map's order button and the
 * overview bar's Order status link: a check once exported, a cross when the
 * export failed, an empty circle while it is pending, not exported, or
 * there is no order yet. */
export const ExportStatusIcon = ({
  status,
  className,
}: {
  status: ExportStatusClass
  className?: string
}) => {
  const Icon = ICON[status]
  return (
    <Icon
      data-testid="order-export-status-icon"
      data-status={status}
      className={cn("h-4 w-4 shrink-0", COLOR[status], className)}
      aria-hidden
    />
  )
}
